export const MAX_DIAGNOSTIC_DOWNLOADS = 10;

export function formatDiagnosticBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDiagnosticDate(value: string, locale = 'ko-KR'): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function toggleDiagnosticSelection(
  selected: ReadonlySet<string>,
  id: string,
  checked: boolean
): Set<string> {
  const next = new Set(selected);
  if (checked) next.add(id);
  else next.delete(id);
  return next;
}

export function toggleDiagnosticPageSelection(
  selected: ReadonlySet<string>,
  pageIds: string[],
  checked: boolean
): Set<string> {
  const next = new Set(selected);
  for (const id of pageIds) {
    if (checked) next.add(id);
    else next.delete(id);
  }
  return next;
}
